/**
 * src/i18n/fr.piedDePage.ts
 *
 * Messages du pied de page ajoutés le 2026-10-04 (porte de NOLAS 9d2063a) :
 * la ligne « Organisé par » quand l'événement déclare ses organisateurs
 * (tne_events.organizer). Fusionné dans fr.ts. Aucune identité en dur :
 * le nom vient de la base, par le jeton {organizer}.
 *
 * Mikael - chef de projet - 2026-10-04
 */
export const messagesPiedDePageFr: Record<string, string> = {
  'footer.organizer.par': 'Organisé par {organizer}',
};
